export default "__VITE_ASSET__DoEr1ZAR__"